import React, { useState } from 'react';
import { Box, Button, Container, Grid, TextField, Typography } from '@mui/material';
import styled from 'styled-components';
import { Controller, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';

import ApiService from '../../helpers/ApiService';
import { useAuth } from '../../providers/AuthProvider';
import { useDrawer } from '../../providers/DrawerProvider';
import { useCookies } from '../../providers/CookiesProvider';

import { CTA } from '../Common/CTA';

const FormLoginContainer = styled.div`
  form {
    .MuiInputBase-root {
      color: var(--bluegray-600);
      background-color: var(--white);
    }
    .MuiFormHelperText-root {
      color: var(--bluegray-400);
    }
    .MuiFormControlLabel-label  {
      color: var(--white);
    }

    hr {
      border: none;
      border-top: 1px solid rgba(0, 0, 0, 0.15);
      margin: 1rem 5rem;
    }
  }
`;

export const FormLogin = () => {
  const { login, REGISTER_EXPIRES } = useAuth();
  const { cookiesAllowed, setCookiesAllowed } = useCookies();
  const { setFormPanel, setOpenDrawer } = useDrawer();

  const [ isLoading, setIsLoading ] = useState(false);
  const { register, handleSubmit, formState: {errors}, control } = useForm();

  const onSave = async data => {
    setIsLoading(true);
    if(!cookiesAllowed) {
      Swal.fire({
        icon: 'info',
        title: 'Uso de Cookies',
        text: 'Para prosseguir, é necessário que você concorde com a utilização de cookies para sua melhor experiência.',
        confirmButtonText: "Concordar e continuar",
        focusConfirm: true,
      }).then(result => {
        if(result.isConfirmed) {
          localStorage.setItem(process.env.REACT_APP_ACCEPT_COOKIES, true);
          setCookiesAllowed(true);
          submitLogin(data);
        }
        else {
          setIsLoading(false);
        }
      });
      return;
    }
    submitLogin(data);
  }

  const submitLogin = async (data) => {
    ApiService.post('user/login', data).then(( {data, status} ) => {
      if ( status === 200 ) {
        setOpenDrawer(false);
        setIsLoading(false);
        login(data.token);
      }
    })
    .catch( (error) => {
      if ( error && error.status === 400 ) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'E-mail ou senha incorretos',
          confirmButtonText: "Vou tentar novamente",
          focusConfirm: true,
        });
      }
      else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Ocorreu um erro desconhecido. Tente novamente mais tarde.',
          confirmButtonText: "Entendi"
        });
      }
      setIsLoading(false);
    });
  }

  const onForgetMyPassword = () => {
    setFormPanel('forgotPassword')
  }

  return (
    <FormLoginContainer>
      <Container>
        <form onSubmit={handleSubmit(onSave)}>
        <Grid container spacing={1}>
            <Grid item sm={12} xs={12} align="center">
              <Box mt={4} mb={2}>
                <Typography variant="body1" className="middle--text">
                  Preencha os campos com seus dados
                </Typography>
              </Box>
            </Grid>
            <Grid item sm={12} xs={12}>
              <Controller
                name="email"
                control={control}
                defaultValue=""
                render={ ({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextField
                    id='emailRegister'
                    type="email"
                    label="E-mail"
                    placeholder="E-mail"
                    variant="outlined"
                    fullWidth
                    value={value}
                    onChange={(e) => onChange(String(e.target.value).toLowerCase())}
                    error={!!error}
                    helperText={error ? "E-mail inválido" : null}
                    // {...register('email', { required: true, pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ })}
                  />
                )}
                rules={{ required: 'E-mail obrigatório', pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ }}
                register
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <TextField
                variant="outlined"
                fullWidth
                label="Senha"
                placeholder="Senha"
                name="password"
                type="password"
                {...register('password', { required: true, minLength: 6 })}
                error={errors.password}
                helperText={errors.password && "Senha deve conter pelo menos 6 caracteres"}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <Button
                variant="text"
                className="dark--text small-text bold-text"
                size='small'
                onClick={onForgetMyPassword}
              >
                Esqueci minha senha
              </Button>
            </Grid>
            <Grid item sm={12} xs={12} align="center">
              <CTA type="submit" disabled={isLoading}>
                Entrar
              </CTA>
            </Grid>
            { REGISTER_EXPIRES > (new Date().getTime()) &&(
              <Grid item sm={12} xs={12} align="center">
                <hr />
                <Box mb={4}>
                  <Typography variant="body1" className="dark--text" gutterBottom>
                    Ainda não possui uma conta? <span className="bold-text button-text" onClick={ () => setFormPanel("register") }>Cadastre-se agora</span>!
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
        </form>
      </Container>
    </FormLoginContainer>
  )
}